import { Container } from '@chakra-ui/layout';
import { Fade } from './Fade';
import React from 'react';

type FormContainerProps = { children: React.ReactNode };
export const FormContainer = ({ children }: FormContainerProps) => (
  <Fade>
    <Container padding={0} paddingBottom={8} w={['xs', 'md', 'xl']}>
      {children}
    </Container>
  </Fade>
);
